<h2 mat-dialog-title class="dialog-header">{{ 'finance.invoice.convert.title' | traduccion }}
  <button mat-icon-button class="close-btn" (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
</h2>

<mat-dialog-content class="dialog-content">
  <div appGridColumns [colsLg]="1" [colsMd]="1" [colsSm]="1">
    <mat-card class="assign-card">
      <mat-card-content>
        <mat-hint class="section-hint">{{ 'finance.invoice.convert.selectedUser' | traduccion }}</mat-hint>

        <div>
          <app-user-search-select
            [(selectedUser)]="selectedUser"
            [label]="'finance.invoice.convert.selectedUser'"
            [noDataLabel]="'finance.invoice.convert.selectedUser.nodata'">
          </app-user-search-select>
        </div>

        <h6 class="section-title">{{ 'finance.invoice.convert.table.title' | traduccion }}</h6>

        <div class="table-desktop-view">
          <app-data-table
            preset="modal"
            shellClass="table-card mat-elevation-z1"
            [dataSource]="dataSource"
            [displayedColumns]="displayedColumns"
            [emptyMessage]="'No hay facturas seleccionadas.'"
            [showPaginator]="true"
            [clientPagination]="true"
            [pageSize]="10"
            [pageSizeOptions]="[10, 25, 50]"
            [showFirstLastButtons]="true"
            [stickyHeader]="true">
            <ng-container matColumnDef="invoiceNumber">
              <th mat-header-cell *matHeaderCellDef>{{ 'finance.invoice.convert.table.header.invoiceNumber' | traduccion }}</th>
              <td mat-cell *matCellDef="let element">{{ element.invoiceNumber }}</td>
            </ng-container>

            <ng-container matColumnDef="type">
              <th mat-header-cell *matHeaderCellDef>{{ 'finance.invoice.convert.table.header.type' | traduccion }}</th>
              <td mat-cell *matCellDef="let element">
                <app-data-table-badge
                  [label]="element.type"
                  [tone]="element.type === 'SIMPLIFICADA' ? 'warning' : 'success'">
                </app-data-table-badge>
              </td>
            </ng-container>

            <ng-container matColumnDef="idClient">
              <th mat-header-cell *matHeaderCellDef>{{ 'finance.invoice.convert.table.header.idClient' | traduccion }}</th>
              <td mat-cell *matCellDef="let element">{{ element.idClient }}</td>
            </ng-container>

            <ng-container matColumnDef="createdAt">
              <th mat-header-cell *matHeaderCellDef>{{ 'finance.invoice.convert.table.header.createdAt' | traduccion }}</th>
              <td mat-cell *matCellDef="let element">{{ element.createdAt | date: appService.FORMAT_DATETIME }}</td>
            </ng-container>
          </app-data-table>
        </div>

        <div class="table-mobile-view" *ngIf="selectedRows.length > 0; else invoiceMobileEmpty">
          <article class="invoice-mobile-card" *ngFor="let element of selectedRows">
            <div class="invoice-mobile-top">
              <div class="invoice-mobile-number">{{ element.invoiceNumber }}</div>
              <app-data-table-badge
                [label]="element.type"
                [tone]="element.type === 'SIMPLIFICADA' ? 'warning' : 'success'">
              </app-data-table-badge>
            </div>

            <div class="invoice-mobile-grid">
              <div class="invoice-mobile-item">
                <span class="invoice-mobile-label">{{ 'finance.invoice.convert.table.header.idClient' | traduccion }}</span>
                <strong>{{ element.idClient || '-' }}</strong>
              </div>

              <div class="invoice-mobile-item">
                <span class="invoice-mobile-label">{{ 'finance.invoice.convert.table.header.createdAt' | traduccion }}</span>
                <strong>{{ element.createdAt | date: appService.FORMAT_DATETIME }}</strong>
              </div>
            </div>
          </article>
        </div>

        <ng-template #invoiceMobileEmpty>
          <div class="invoice-mobile-empty">No hay facturas seleccionadas.</div>
        </ng-template>
      </mat-card-content>
    </mat-card>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="dialog-footer">
  <button
    *ngIf="selectedRows.length > 0"
    mat-raised-button
    color="primary"
    [disabled]="!selectedUser"
    (click)="convertInvoiceMassive()">
    <mat-icon>link</mat-icon>
    {{ 'finance.invoice.convert.action' | traduccion }}
  </button>
</mat-dialog-actions>
